interface DomainsRegistry {
  us_domain: string
  eu_domain: string
  it_domain: string
  fr_domain: string
  uk_domain: string
  dk_domain: string
  de_domain: string
  us_isocode?: string[]
  row_domain: string
  eu_isocode?: string[]
  it_isocode?: string[]
  fr_isocode?: string[]
  uk_isocode?: string[]
  dk_isocode?: string[]
  de_isocode?: string[]
}

/**
 * It returns the URL of the store for the selected country.
 *
 * @param selectedCountry - The country code of the country you want to switch the domain to.
 * @param domainsRegistry - A object that holds the domains and the isocodes of the store for each country.
 */
export const getStoreUrlByCountry = (
  selectedCountry: string,
  domainsRegistry: DomainsRegistry,
): string => {
  let domain = domainsRegistry.row_domain

  if (domainsRegistry.eu_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.eu_domain
  }

  if (domainsRegistry.it_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.it_domain
  }

  if (domainsRegistry.fr_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.fr_domain
  }

  if (domainsRegistry.uk_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.uk_domain
  }

  if (domainsRegistry.dk_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.dk_domain
  }

  if (domainsRegistry.us_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.us_domain
  }

  if (domainsRegistry.de_isocode?.includes(selectedCountry)) {
    domain = domainsRegistry.de_domain
  }

  return `https://${domain}?deliveryCountry=${selectedCountry}`
}
